import React, {useState} from 'react'
import "./Navbar.css"
import {logosvg} from "../../constants"
// Toggle Icons from react icons
import { FaTimes } from "react-icons/fa";
import { CgMenuRightAlt } from "react-icons/cg";

function Navbar() {
  const [navbar, setNavbar] = useState(false);

  // Open navbar
  function openNavbar() {
    setNavbar(prev => !prev)
  }
  // close navbar
  function closeNavbar() {
       setNavbar(prev => !prev)
  }

  return (
    <div className="App_Navbar">
       
      {/* DESKTOP NAVBAR */}
      <div className="Navbar_Desktop flex">
        <div className=" flex">
          <img src={logosvg} alt="Logo" className="logo_img" />

          <div className="desktop_links">
            <nav>
              <ul className="flex">
                <li>
                  <a href="#Home">Home</a>
                </li>
                <li>
                  <a href="#About">What is GPT3</a>
                </li>
                <li>
                  <a href="#OpenAi">Open AI</a>
                </li>
                <li>
                  <a href="#CaseStudy">Case Studies</a>
                </li>
                <li>
                  <a href="#Library">Library</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        
        <div className="buttons flex">
          <li>
            <a href="#Form" className='btn sign_in-btn'>Sign In</a>
          </li>
          <li>
            <a href="#Form" className='btn sign_up-btn'>Sign Up</a>
          </li>
        </div>
      </div>
      
      {/* MOBILE NAVBAR */}
      <div className="Navbar_Mobile">
        <div className=" flex">
         <img src = {logosvg}alt = "Logo" className = "logo_img" />

          <div className="Nav_toggle">
            {navbar ? <FaTimes className="toggle_btn" onClick={openNavbar}/> : <CgMenuRightAlt className='toggle_btn' onClick={closeNavbar} />}
          </div>
           
          {navbar && (
            <div className="Nav_Links">
                <nav>
                    <ul>
                      <li onClick={closeNavbar}>
                        <a href="#Home">Home</a>
                      </li>
                      <li onClick={closeNavbar}>
                        <a href="#About">What is GPT3?</a>
                      </li>
                      <li onClick={closeNavbar}>
                        <a href="#OpenAi">Open AI</a>
                      </li>
                      <li onClick={closeNavbar}>
                        <a href="#CaseStudy">Case Studies</a>
                      </li>
                      <li onClick={closeNavbar}>
                        <a href="#Library">Library</a>
                      </li>
                      <li>
                        <a href="#Form" className='btn sign_in-btn'>Sign In</a>
                      </li>
                      <li>
                        <a href="#Form" className='btn sign_up-btn'>Sign Up</a>
                      </li>
                  </ul>
                </nav>
          </div>
        )}
        </div>
      </div>
    </div>
  )
}

export default Navbar